import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ErrorCodeEnum } from '@/config';
import { IssuePromoCodeRequest, PromoHistoryRequest } from '@/api';
import { PromoHistoryData } from '../models';

export interface PromoHistorySliceState {
  data: PromoHistoryData;
  loading: boolean;
  error: string | null;
  errorCode: ErrorCodeEnum | null;
}

const initialState: PromoHistorySliceState = {
  data: null,
  loading: false,
  error: null,
  errorCode: null,
};

const promoHistorySlice = createSlice({
  name: 'promoHistory',
  initialState,
  reducers: {
    setData: (state, action: PayloadAction<PromoHistoryData>) => ({
      ...state,
      data: action.payload,
    }),
    setLoading: (state, action: PayloadAction<boolean>) => ({
      ...state,
      loading: action.payload,
    }),
    setError: (state, action: PayloadAction<string | null>) => ({
      ...state,
      error: action.payload,
    }),
    setErrorCode: (state, action: PayloadAction<ErrorCodeEnum | null>) => ({
      ...state,
      errorCode: action.payload,
    }),
    fetchPromoHistory: (state, action: PayloadAction<PromoHistoryRequest>) => ({
      ...state,
      error: null,
      loading: true,
    }),
    issuePromoCode: (state, action: PayloadAction<IssuePromoCodeRequest>) => ({
      ...state,
      error: null,
      loading: true,
      errorCode: null,
    }),
    addData: (state, action: PayloadAction<PromoHistoryData>) => {
      if (action.payload === null) {
        return {
          ...state,
          data: null,
        };
      }

      const currentItems = JSON.parse(JSON.stringify(state.data?.items || []));
      const { items, ...newData } = action.payload;

      return {
        ...state,
        data: {
          ...state.data,
          ...newData,
          items: [...currentItems, ...items],
        },
      };
    },
  },
});

export { promoHistorySlice };
